export default __webpack_public_path__ + "static/media/icon-protesis.ffe4630b.svg";